import { convertLabDateRangeToUtc } from "Utils/Common/LabTimeZone";

export function getRowId(row: any): string | number {
  const id = row?.id ?? row?.batchId;
  if (id !== null && id !== undefined && id !== "") return id;

  const oncologyBatchId = row?.oncologyBatchId;
  if (
    oncologyBatchId !== null &&
    oncologyBatchId !== undefined &&
    oncologyBatchId !== 0
  )
    return oncologyBatchId;

  if (row?.batchCode) return row.batchCode;
  if (row?._clientRowId !== null && row?._clientRowId !== undefined)
    return row._clientRowId;

  return row?.rowStatus ? "draft-new" : "unknown";
}

export function pickField(row: any, ...keys: string[]): string {
  for (const k of keys) {
    if (row?.[k] !== undefined && row?.[k] !== null && row?.[k] !== "") {
      return row[k];
    }
  }
  return "";
}

// The picked lab days ("MM/DD/YYYY to MM/DD/YYYY") as a UTC range for the request: dates only, or the
// exact window once SEND_UTC_TIME_WITH_DATE_RANGE_FILTERS is turned on. Without a lab timezone the picked
// range is sent as picked.
export function toRunDateQuery(
  range: string,
  labTimeZone?: string | null
): string {
  return range ? (convertLabDateRangeToUtc(range, labTimeZone) ?? range) : "";
}

export function convertGDNAFlagToBoolean(flag: string): boolean | null {
  if (!flag || flag.trim() === "") return null;
  const upperFlag = flag.toUpperCase().trim();
  if (upperFlag === "PASS") return true;
  if (upperFlag === "FAIL") return false;
  if (["Y", "YES", "TRUE", "1", "P", "POSITIVE"].includes(upperFlag))
    return true;
  if (["N", "NO", "FALSE", "0", "NEGATIVE"].includes(upperFlag)) return false;
  return null;
}
